/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ManagedCompaniesMode {
    AllCompanies = 1,
    CustomSelection = 2,
}